<script>
    import {getNextInputId} from '../../helper/UIHelper';  
    export let model;
    export let list;
    export let label;
    let className = "";
    export {className as class};

    let uid = getNextInputId();
</script>
<!-- 
<div class="{className}">
  <label for="{uid}">{label}</label>
  <div class="inline-block relative">
    <select id="{uid}" bind:value={model} class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
    {#each list as item}
          <option value={item.value}>
              {item.text}
          </option>
      {/each}
    </select>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
    </div>
  </div>
</div> -->

<div class="{className}">
  {#if label != null}
  <label for="{uid}" class="block text-sm font-medium leading-5 text-gray-700">{label}</label>
  {/if}
  <select id="{uid}" bind:value={model} on:change class="mt-1 block form-select w-full py-2 px-3 py-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
    {#each list as item}
      <option value={item.Value}>
        {item.Text}
      </option>
    {/each}
  <select>
</div>